/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CreateRequestBuilderRequestsMetadata, type CreateRequestBuilder } from './create/index.js';
// @ts-ignore
import { CreateForTourOperatorRequestBuilderRequestsMetadata, type CreateForTourOperatorRequestBuilder } from './createForTourOperator/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { GetForTourOperatorRequestBuilderRequestsMetadata, type GetForTourOperatorRequestBuilder } from './getForTourOperator/index.js';
// @ts-ignore
import { type WithRequestItemRequestBuilder, WithRequestItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentReport
 */
export interface AllotmentReportRequestBuilder extends BaseRequestBuilder<AllotmentReportRequestBuilder> {
    /**
     * The Create property
     */
    get create(): CreateRequestBuilder;
    /**
     * The CreateForTourOperator property
     */
    get createForTourOperator(): CreateForTourOperatorRequestBuilder;
    /**
     * The GetForTourOperator property
     */
    get getForTourOperator(): GetForTourOperatorRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * Gets an item from the ApiSdk.AllotmentReport.item collection
     * @param requestId Unique identifier of the item
     * @returns {WithRequestItemRequestBuilder}
     */
     byRequestId(requestId: number) : WithRequestItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentReportRequestBuilderUriTemplate = "{+baseurl}/AllotmentReport";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentReportRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentReportRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byRequestId: {
        requestsMetadata: WithRequestItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["requestId"],
    },
    create: {
        requestsMetadata: CreateRequestBuilderRequestsMetadata,
    },
    createForTourOperator: {
        requestsMetadata: CreateForTourOperatorRequestBuilderRequestsMetadata,
    },
    getForTourOperator: {
        requestsMetadata: GetForTourOperatorRequestBuilderRequestsMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
